module.exports = __webpack_public_path__ + "static/media/white-play-icon.bc73518a.svg";